import { Loader2 } from 'lucide-react';

export function FullPageSpinner() {
  return (
    <div className='min-h-screen flex items-center justify-center' role='status' aria-label='Loading'>
      <Loader2 className='h-10 w-10 animate-spin text-primary' aria-hidden='true' />
    </div>
  );
}
